import React from "react";

export const ErrorPageContext = React.createContext<(active: boolean) => void>(() => {});
